import React, { Component } from 'react';
import { Button, Card, Col, Divider, Form, Input, message, Row, Table } from 'antd';
import { Link } from 'react-router';
import { queryDownloadWageTemplate, queryHrWageList, queryImportWage } from '@api/hr/wage';
import { queryDownloadBonusTemplate, queryImportBonus } from '@api/hr/bonus';
import ModalImportWage from './ModalImportWage';
import ModalImportBonus from './ModalImportBonus';

const FormItem = Form.Item;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      total: 0,
      pageNo: 1,
      wageVisible: false,
      bonusVisible: false,
      wageLoading: false,
      bonusLoading: false,
    };
  }

  componentDidMount() {
    this.loadData(1);
  }

  loadData = (pageNo, condition) => {
    const params = {};
    const context = this;
    const no = this.state.pageNo;
    const current = pageNo || no;
    params.limit = 15;
    params.start = current;
    params.condition = condition || '';
    this.setState({
      pageNo,
    });
    queryHrWageList(params).then(res => {
      if (res.statusCode === 200) {
        context.setState({
          data: res.data,
          total: res.totalSize,
          isLoading: false,
          currentTotal: res.data.currentTotal,
        });
      }
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.loadData(1, values.condition);
      }
    });
  };

  handleFormReset = e => {
    e.preventDefault();
    this.props.form.resetFields();
    this.loadData(1);
  };

  // 工资导入
  handleImportWage = params => {
    this.setState({ wageLoading: true });
    queryImportWage(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.handleWageVisible(false);
        this.loadData(1);
      } else {
        message.error(res.message);
      }
      this.setState({ wageLoading: false });
    });
  };

  handleImportBonus = params => {
    this.setState({ bonusLoading: true });
    queryImportBonus(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.handleBonusVisible(false);
        this.loadData(1);
      } else {
        message.error(res.message);
      }
      this.setState({ bonusLoading: false });
    });
  };

  handleWageVisible = flag => {
    this.setState({
      wageVisible: !!flag,
    });
  };

  handleBonusVisible = flag => {
    this.setState({
      bonusVisible: !!flag,
    });
  };

  renderSearchForm = () => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    return (
      <Form layout="inline" onSubmit={this.handleSubmit} style={{ textAlign: 'right' }}>
        <FormItem label="搜索条件">
          {getFieldDecorator('condition')(<Input placeholder="请输入" />)}
        </FormItem>
        <FormItem>
          <Button type="primary" htmlType="submit">
            查询
          </Button>
          <Button style={{ marginLeft: 8, marginRight: '-16px' }} onClick={this.handleFormReset}>
            重置
          </Button>
        </FormItem>
      </Form>
    );
  };

  columns = () => {
    return [
      {
        title: '单位名称',
        dataIndex: 'name',
      },
      {
        title: '操作',
        dataIndex: 'done',
        render: (text, record) => {
          return (
            <span>
              <Link to={`/hr/wage/wageCompanyMonth/${record.uuid}`}>查看工资</Link>
              <Divider type="vertical" />
              <Link to={`/hr/wage/bonusCompanyYear/${record.uuid}`}>查看年终奖</Link>
            </span>
          );
        },
      },
    ];
  };

  render() {
    const { data, total, wageVisible, bonusVisible, wageLoading, bonusLoading } = this.state;
    const pagination = {
      showSizeChanger: false,
      pageSize: 15,
      total,
      current: this.state.pageNo,
      onChange: current => {
        this.loadData(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    return (
      <Card>
        <div className="tableList">
          <Row>
            <Col span={13}>
              <FormItem>
                <Button
                  icon="plus"
                  style={{ marginRight: '8px' }}
                  size="small"
                  onClick={() => this.handleWageVisible(true)}
                >
                  导入工资
                </Button>
                <Button
                  icon="plus"
                  style={{ marginRight: '8px' }}
                  size="small"
                  onClick={() => queryDownloadWageTemplate()}
                >
                  工资模板下载
                </Button>
                <Button
                  icon="plus"
                  style={{ marginRight: '8px' }}
                  size="small"
                  onClick={() => this.handleBonusVisible(true)}
                >
                  导入年终奖
                </Button>
                <Button
                  icon="plus"
                  style={{ marginRight: '8px' }}
                  size="small"
                  onClick={() => queryDownloadBonusTemplate()}
                >
                  年终奖模板下载
                </Button>
              </FormItem>
            </Col>
            <Col span={11}>
              <div className="tableListForm">{this.renderSearchForm()}</div>
            </Col>
          </Row>
        </div>
        <Table
          rowKey="uuid"
          rowSelection={{}}
          columns={this.columns()}
          dataSource={data}
          pagination={pagination}
        />
        {wageVisible ? (
          <ModalImportWage
            wageLoading={wageLoading}
            handleSubmit={this.handleImportWage}
            handleCancel={() => this.handleWageVisible(false)}
          />
        ) : null}
        {bonusVisible ? (
          <ModalImportBonus
            bonusLoading={bonusLoading}
            handleSubmit={this.handleImportBonus}
            handleCancel={() => this.handleBonusVisible(false)}
          />
        ) : null}
      </Card>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Index);



// WEBPACK FOOTER //
// ./src/components/hr/wageImport/Index.js